import { useLocation } from 'react-router-dom'

const useSearchParams = (key) => {
  const keyValue = new URLSearchParams(useLocation().search).get(key)

  if (!keyValue) {
    return ''
  } else {
    return keyValue
  }
}

export default useSearchParams
